import { commonConstants, paymentConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { commonEffect } from '../_effects';

export const commonActions = {
  nationality,
  getCustDetailsByCode,
  currency,
  source,
  purpose,
  branches,
  country,
  services,
  getAgentDetails,
  serviceProvider,
  typeDetails,
  getCountries,
};
function getCountries(countries) {
  return (dispatch) => {
    dispatch(request(countries));
    commonEffect.getCountries(countries).then(
      (countries) => {
        dispatch(success(countries));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(country) {
    return { type: commonConstants.COUNTRY_REQUEST, country };
  }
  function success(country) {
    return { type: commonConstants.COUNTRY_SUCCESS, country };
  }
  function failure(error) {
    return { type: commonConstants.COUNTRY_FAILURE, error };
  }
}

function nationality(national) {
  return (dispatch) => {
    dispatch(request(national));
    commonEffect.nationality(national).then(
      (national) => {
        dispatch(success(national));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(national) {
    return { type: commonConstants.NATIONALITY_REQUEST, national };
  }
  function success(national) {
    return { type: commonConstants.NATIONALITY_SUCCESS, national };
  }
  function failure(error) {
    return { type: commonConstants.NATIONALITY_FAILURE, error };
  }
}

function typeDetails(typeDetails) {
  return (dispatch) => {
    dispatch(request(typeDetails));
    commonEffect.typeDetails(typeDetails).then(
      (typeDetails) => {
        dispatch(success(typeDetails));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(typeDetails) {
    return { type: commonConstants.TYPEDETAILS_REQUEST, typeDetails };
  }
  function success(typeDetails) {
    return { type: commonConstants.TYPEDETAILS_SUCCESS, typeDetails };
  }
  function failure(error) {
    return { type: commonConstants.TYPEDETAILS_FAILURE, error };
  }
}
function country(countries) {
  return (dispatch) => {
    dispatch(request(countries));
    commonEffect.country(countries).then(
      (countries) => {
        dispatch(success(countries));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(country) {
    return { type: commonConstants.COUNTRY_REQUEST, country };
  }
  function success(country) {
    return { type: commonConstants.COUNTRY_SUCCESS, country };
  }
  function failure(error) {
    return { type: commonConstants.COUNTRY_FAILURE, error };
  }
}
function serviceProvider(serviceProvider) {
  return (dispatch) => {
    dispatch(request(serviceProvider));
    commonEffect.serviceProvider(serviceProvider).then(
      (ServiceProvider) => {
        dispatch(success(ServiceProvider));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(serviceProvider) {
    return { type: commonConstants.SERVICEPROVIDER_REQUEST, serviceProvider };
  }
  function success(serviceProvider) {
    return { type: commonConstants.SERVICEPROVIDER_SUCCESS, serviceProvider };
  }
  function failure(error) {
    return { type: commonConstants.SERVICEPROVIDER_FAILURE, error };
  }
}
function getCustDetailsByCode(profile) {
  return (dispatch) => {
    dispatch(request(profile));
    commonEffect.getCustDetailsByCode(profile).then(
      (profile) => {
        dispatch(success(profile));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(profile) {
    return { type: commonConstants.GET_CUST_DETAIL_CODY_REQUEST, profile };
  }
  function success(profile) {
    return { type: commonConstants.GET_CUST_DETAIL_CODY_SUCCESS, profile };
  }
  function failure(error) {
    return { type: commonConstants.GET_CUST_DETAIL_CODY_FAILURE, error };
  }
}

function currency(currency) {
  return (dispatch) => {
    dispatch(request(currency));
    commonEffect.currency(currency).then(
      (currency) => {
        dispatch(success(currency));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(currency) {
    return { type: commonConstants.CURRENCY_REQUEST, currency };
  }
  function success(currency) {
    return { type: commonConstants.CURRENCY_SUCCESS, currency };
  }
  function failure(error) {
    return { type: commonConstants.CURRENCY_FAILURE, error };
  }
}

function source(source) {
  return (dispatch) => {
    dispatch(request(source));
    commonEffect.getSource(source).then(
      (source) => {
        dispatch(success(source));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(source) {
    return { type: paymentConstants.GET_SOURCE_REQUEST, source };
  }
  function success(source) {
    return { type: paymentConstants.GET_SOURCE_SUCCESS, source };
  }
  function failure(error) {
    return { type: paymentConstants.GET_SOURCE_FAILURE, error };
  }
}

function purpose(purpose) {
  return (dispatch) => {
    dispatch(request(purpose));
    commonEffect.getPurpose(purpose).then(
      (purpose) => {
        dispatch(success(purpose));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(purpose) {
    return { type: paymentConstants.GET_PURPOSE_REQUEST, purpose };
  }
  function success(purpose) {
    return { type: paymentConstants.GET_PURPOSE_SUCCESS, purpose };
  }
  function failure(error) {
    return { type: paymentConstants.GET_PURPOSE_FAILURE, error };
  }
}

function branches(branches) {
  return (dispatch) => {
    dispatch(request(branches));
    commonEffect.getOrgBranch(branches).then(
      (branches) => {
        dispatch(success(branches));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(branches) {
    return { type: commonConstants.GET_ORG_BRANCH_REQUEST, branches };
  }
  function success(branches) {
    return { type: commonConstants.GET_ORG_BRANCH_SUCCESS, branches };
  }
  function failure(error) {
    return { type: commonConstants.GET_ORG_BRANCH_FAILURE, error };
  }
}
function services(services) {
  return (dispatch) => {
    dispatch(request(services));
    commonEffect.services(services).then(
      (services) => {
        dispatch(success(services));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(services) {
    return { type: commonConstants.SERVICES_REQUEST, services };
  }
  function success(services) {
    return { type: commonConstants.SERVICES_SUCCESS, services };
  }
  function failure(error) {
    return { type: commonConstants.SERVICES_FAILURE, error };
  }
}

function getAgentDetails(getAgentDetails) {
  return (dispatch) => {
    dispatch(request(getAgentDetails));
    commonEffect.getAgentDetails(getAgentDetails).then(
      (getAgentDetails) => {
        dispatch(success(getAgentDetails));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(getAgentDetails) {
    return { type: commonConstants.GET_AGENT_DETAILS_REQUEST, getAgentDetails };
  }
  function success(getAgentDetails) {
    return { type: commonConstants.GET_AGENT_DETAILS_SUCCESS, getAgentDetails };
  }
  function failure(error) {
    return { type: commonConstants.GET_AGENT_DETAILS_FAILURE, error };
  }
}
